import { EntityEnums } from "../enums";

export const moodDict = [
  {
    value: EntityEnums.Mood.Indication,
    label: "indication",
    info: "",
  },
  {
    value: EntityEnums.Mood.Question,
    label: "question",
    info: "",
  },
  {
    value: EntityEnums.Mood.Condition,
    label: "condition",
    info: "",
  },
  {
    value: EntityEnums.Mood.Possibility,
    label: "possibility",
    info: "",
  },
  {
    value: EntityEnums.Mood.Probability,
    label: "probability",
    info: "",
  },
  {
    value: EntityEnums.Mood.Certitude,
    label: "certitude",
    info: "",
  },
  {
    value: EntityEnums.Mood.Wish,
    label: "wish",
    info: "",
  },
  {
    value: EntityEnums.Mood.Expectation,
    label: "expectation",
    info: "",
  },
  {
    value: EntityEnums.Mood.Order,
    label: "order",
    info: "",
  },
  {
    value: EntityEnums.Mood.Licence,
    label: "licence",
    info: "",
  },
  {
    value: EntityEnums.Mood.Ability,
    label: "ability",
    info: "",
  },
  {
    value: EntityEnums.Mood.Belief,
    label: "belief",
    info: "",
  },
  {
    value: EntityEnums.Mood.Allegation,
    label: "allegation",
    info: "",
  },
  {
    value: EntityEnums.Mood.Semblance,
    label: "semblance",
    info: "",
  },
  {
    value: EntityEnums.Mood.Rectitude,
    label: "rectitude",
    info: "",
  },
];
